import { render, staticRenderFns } from "./LevelsView.vue?vue&type=template&id=d5fa7f58&"
import script from "./LevelsView.vue?vue&type=script&lang=js&"
export * from "./LevelsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports